import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IFloatingFilterAngularComp } from "ag-grid-angular";
import { IFloatingFilterParams, ISimpleFilter } from "ag-grid-community";

export interface CustomFilterParams {
  options: any[];
  filterType: string;
}

@Component({
  standalone: true,
  imports: [FormsModule],
  template: `
    <select style="width: calc(100% - 16px)" [(ngModel)]="currentValue" (change)="onSelectBoxChanged($event)">
      @for (option of params.options; track option) {
        <option [value]="option.value">{{option.label}}</option>
      }
    </select>
    <span class="custom-filter-clear" (click)="currentValue=null; onSelectBoxChanged(undefined)">&times;</span>
  `
})
export class CustomSelectFilterComponent implements IFloatingFilterAngularComp {
  params!: IFloatingFilterParams<ISimpleFilter> & CustomFilterParams;
  currentValue: number | null | string = null;

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomFilterParams): void {
    this.params = params;
  }

  onParentModelChanged(parentModel: any) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  onSelectBoxChanged(e: any) {
    if (!this.currentValue) {
      // Remove the filter
      this.params.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('null', null);
      });
      return;
    }

    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged(this.params.filterType, this.currentValue);
    });
  }
}


@Component({
  standalone: true,
  imports: [FormsModule],
  template: `<input style="width: calc(100% - 30px)" type="text" [(ngModel)]="currentValue"
               (keyup)="onInputBoxChanged($event)"/><span class="custom-filter-clear" (click)="currentValue=null; onInputBoxChanged(undefined)">&times;</span>`
})
export class CustomTextFilterComponent implements IFloatingFilterAngularComp {
  params!: IFloatingFilterParams<ISimpleFilter> & CustomFilterParams;
  currentValue: number | null | string = null;
  style: any;

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomFilterParams): void {
      this.params = params;
  }

  onParentModelChanged(parentModel: any) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  onInputBoxChanged(e: any) {
    if (!this.currentValue) {
      // Remove the filter
      this.params.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('null', null);
      });
      return;
    }

    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('contains', this.currentValue);
    });
  }
}
